module.exports = __webpack_public_path__ + "static/body-74b934c8aeaace46cea1627c7c36b3e8.png";